// extracted by mini-css-extract-plugin
module.exports = {"type":"requestItem_type__aMG6I","buttons":"requestItem_buttons__1naPK","dismissWrapper":"requestItem_dismissWrapper__1iSFg"};